export default __webpack_public_path__ + "static/media/MAHANTESH.bf09cdfe.JPG";